import EventEmitter from 'eventemitter3';

export enum EditorTools {
  Pointer = 'Pointer',
  DrawRectangle = 'DrawRectangle',
  DrawLine = 'DrawLine',
  DrawArrow = 'DrawArrow',
  DrawText = 'DrawText',
  CreatePunch = 'CreatePunch',
  PostRFI = 'PostRFI',
}

// Note: It might be good to have this extends "Tracked"
class Tool<T> extends EventEmitter {
  _tool: T;

  constructor(initialTool: T) {
    super();

    this._tool = initialTool;
  }

  get tool(): T {
    return this._tool;
  }

  set tool(nextTool: T) {
    this._tool = nextTool;
    this.emit('toolchange', this._tool);
  }
}

export default Tool;
